import styled from "@emotion/styled";

const TopbarShellTitle = styled.h3`
  ${({theme}) => theme.text.header3}
`;

export default TopbarShellTitle;
